import { ApiResponse } from "../../apiResponse";
import Axios from "../../axios";

export function indexReadingScheduleSlots(): Promise<ApiResponse> {
  return Axios.get("/v1/candidates/schedule_slots");
}

export function showAvailableSlots(
  startDate: string,
  endDate: string
): Promise<ApiResponse> {
  return Axios.get(
    `v1/candidates/schedule_slots/availability?start_date=${startDate}&end_date=${endDate}`
  );
}

export function showAvailableTutors(
  date: string,
  startTime: number
): Promise<ApiResponse> {
  return Axios.get(
    `/v1/candidates/schedule_slots/available_tutors?start_time=${startTime}&date=${date}`
  );
}

export function updateReadingScheduleSlot(data: object): Promise<ApiResponse> {
  return Axios.put(`/v1/candidates/schedule_slots`, data);
}

export function cancelReadingScheduleSlot(
  slotId: number | string
): Promise<ApiResponse> {
  return updateReadingScheduleSlot({
    schedule_slots_attributes: [
      {
        id: slotId,
        is_canceled: true,
      },
    ],
  });
}
